import { useGetPermitBlueprints } from "../operations/queries/getPermitBlueprints";
import { useGetOrganizations } from "../operations/queries/getOrganizations";
import { useAddPermitBlueprint } from "../operations/mutations/addPermitBlueprint";
import { useUpdatePermitBlueprint } from "../operations/mutations/updatePermitBlueprint";
import { useAddBlueprintToOrganization } from "../operations/mutations/addBlueprintToOrganization";
import PermitBlueprintsList from "../components/PermitBlueprintsList";

const AdminPermitBlueprintsListContainer = () => {
  const { data: blueprintsData, status: getBlueprintsStatus } = useGetPermitBlueprints();
  const { data: organizationsData } = useGetOrganizations();
  const { mutate: addBlueprintMutate, status: addBlueprintStatus } = useAddPermitBlueprint();
  const { mutate: updateBlueprintMutate, status: updateBlueprintStatus } = useUpdatePermitBlueprint();
  const { mutate: addToOrgMutate, status: addToOrgStatus } = useAddBlueprintToOrganization();

  const handleAdd = (name: string, templateJson?: string) => {
    addBlueprintMutate({ variables: { name, templateJson } });
  };

  const handleEdit = (id: string, name: string, templateJson?: string) => {
    updateBlueprintMutate({ variables: { id, name, templateJson } });
  };

  const handleAddToOrganization = (blueprintId: string, organizationId: string, permitTypeName?: string) => {
    addToOrgMutate({ variables: { blueprintId, organizationId, permitTypeName } });
  };

  return (
    <PermitBlueprintsList
      isLoading={getBlueprintsStatus.loading}
      blueprints={blueprintsData?.permitBlueprints}
      organizations={organizationsData?.organizations}
      onAdd={handleAdd}
      addStatus={addBlueprintStatus}
      onEdit={handleEdit}
      editStatus={updateBlueprintStatus}
      onAddToOrganization={handleAddToOrganization}
      addToOrganizationStatus={addToOrgStatus}
    />
  );
};

export default AdminPermitBlueprintsListContainer;
